import { useEffect } from 'react';

type UsePreventDoubleClickOptions = {
  onMouseDown?: (event: MouseEvent) => void;
};

export const preventDoubleClickPropagation = (event: MouseEvent) => {
  if (event.detail > 1) {
    event.stopImmediatePropagation();
    return true;
  }

  return false;
};

export const usePreventDoubleClick = (
  element: HTMLElement | null,
  { onMouseDown }: UsePreventDoubleClickOptions = {},
) => {
  useEffect(() => {
    if (!element) {
      return;
    }

    const abortController = new AbortController();
    const { signal } = abortController;

    const handleMouseDown = (event: MouseEvent) => {
      if (preventDoubleClickPropagation(event)) {
        return;
      }

      onMouseDown?.(event);
    };

    const handleClick = (event: MouseEvent) => {
      preventDoubleClickPropagation(event);
    };

    element.addEventListener('mousedown', handleMouseDown, { capture: true, signal });
    element.addEventListener('click', handleClick, { capture: true, signal });

    return () => {
      abortController.abort();
    };
  }, [element, onMouseDown]);
};
